<div class="referral-social-list {{ documentDirection }}" [ngClass]="visualType" *ngIf="referralLink">
    <div class="referral-social" *ngFor="let referral of referralsArr">
        <div class="social" (opened)="shareOpen($event)" [title]="referral?.subject" [description]="referral.description" [shareButton]="referral.type" [url]="referralLink">
            <div class="social-icon">
                <img [src]="referral.icon_url" alt="">
            </div>
            <span class="title">{{referral.title}}</span>
        </div>
    </div>
</div>